// shim that gets loaded before the apps that use module view
// move import of module-view back into cerego-main-learn-app, cerego-main-create-app
import '../../assets/javascripts/v2/modules/module-view-app.js';
